import React from 'react';

const SvgReload = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 10 12" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M.363 6.862L2.138 5.8a2.72 2.72 0 0 1-.112-.788 2.987 2.987 0 1 1 5.974 0 2.99 2.99 0 0 1-2.787 2.975V6.125L.626 9l4.587 2.875v-1.862a5.012 5.012 0 0 0 4.812-5A5.02 5.02 0 0 0 5.013 0 5.02 5.02 0 0 0 0 5.013c0 .65.125 1.275.363 1.85z"
    />
  </svg>
);

export default SvgReload;
